import { TCommonData, TWidgetProps } from '@libs/types';
import React from 'react';
import success from '../../animations/success.json';
import { sanitizeLottieName } from '../../utils/sanitize';
import { getInlineStyles } from '../../utils/styles';
import { useLottieAnimation } from './useLottieAnimation';

export const SuccessAnimation: React.FC<TWidgetProps<TCommonData>> = ({ widget }) => {
    const sanitizedUid = sanitizeLottieName(widget.uid);
    
    const { element } = useLottieAnimation({
        uid: sanitizedUid,
        animationData: success,
        loop: false,
        autoplay: true,
    });

    return <div data-test={widget.uid} ref={element} style={getInlineStyles({ margin: widget.options?.margin, height: '73px', width: '73px' })} />;
};
